import axios from "axios";

import config from "../../config/config";
import { getToken } from "../../common";

export const addAPIEndpointAPI = async ({
  method,
  description,
  path,
  isEnabled,
}) => {
  const payload = {
    method,
    description,
    path,
    isEnabled,
  };

  return await axios({
    method: "post",
    url: `${config.api.base_url}api-keys/endpoints`,
    data: payload,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default addAPIEndpointAPI;
